import { Address } from 'viem';
import client from './client';
import { PaginationRequest, PaginationResponse } from '../interfaces';
import { qsStringify } from '../shared/utils/QueryString';
import { Bridge } from '../interfaces/BridgeInterface';

const getBridges = async (query: PaginationRequest) => {
  const url = 'api/bridges';
  const res = await client.get<PaginationResponse<Bridge[]>>(
    `${url}?${qsStringify(query)}`
  );

  return res.data;
};

const initBridge = async (type: 'withdraw' | 'deposit', txnHash: Address) => {
  const url = 'api/bridges/init';
  const res = await client.post<{ data: any }>(url, {
    data: { type, txnHash },
  });

  return res.data.data;
};

const provenWithdrawal = async (
  bridgeTxHash: Address,
  proveTxnHash: Address
) => {
  const url = `api/bridges/${bridgeTxHash}`;
  const res = await client.put<{ data: any }>(url, {
    data: { proveTxnHash },
  });

  return res.data.data;
};

const finalizeWithdrawal = async (
  bridgeTxHash: Address,
  finalizeTxnHash: Address
) => {
  const url = `api/bridges/${bridgeTxHash}`;
  const res = await client.put<{ data: any }>(url, {
    data: { finalizeTxnHash },
  });

  return res.data.data;
};

export { getBridges, initBridge, provenWithdrawal, finalizeWithdrawal };
